// extracted by mini-css-extract-plugin
module.exports =  {"root":"QbpgkDg3ti5A4LplutJn","limit":"LkAaFFYUEOHqZ9GUO4P_"};